import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
import { useAuthStore } from '@/store';

const PROFILING_URL =
  import.meta.env.VITE_PROFILING_URL || 'https://staging-profiling.sloxt.com/profiling';

const PUBLIC_PROFILING_URL =
  import.meta.env.VITE_PUBLIC_PROFILING_URL ||
  'https://iw7vulo5k9.execute-api.us-east-1.amazonaws.com/profiling';

// keyFields: false — disable normalization for types whose id is shared
// across multiple employees with different values (e.g. service price per employee).
// Without this, Apollo merges e.g. EmployeeService:abc123 from all employees into
// one cache entry, so every employee ends up showing the same price.
const sharedTypePolicies = {
  typePolicies: {
    EmployeeService: { keyFields: false as const },
    Availability: { keyFields: false as const },
  },
};

const profilingHttpLink = new HttpLink({
  uri: PROFILING_URL,
  fetch: (uri, options) => {
    const accessToken = useAuthStore.getState().accessToken;
    const headers = new Headers(options?.headers);
    if (accessToken) {
      headers.set('authorization', `Bearer ${accessToken}`);
    }
    return fetch(uri, { ...options, headers });
  },
});

export const profilingClient = new ApolloClient({
  link: profilingHttpLink,
  cache: new InMemoryCache(sharedTypePolicies),
});

/** Public client — no auth headers, hits the public profiling endpoint */
export const publicProfilingClient = new ApolloClient({
  link: new HttpLink({ uri: PUBLIC_PROFILING_URL }),
  cache: new InMemoryCache(sharedTypePolicies),
});
